import { makeStyles } from "@material-ui/styles";

const matchContainerStyles = makeStyles(() => ({
	matchContainer: {
		height: "100%",
		overflow: "auto"
	}
}));

export default matchContainerStyles;
